import { Children, type ReactNode } from "react";

/**
 * Infinite horizontal ticker. Children are duplicated once so the track can
 * loop seamlessly at -50%. Pauses on hover.
 */
export function Marquee({
  children,
  durationSec = 34,
  className = "",
}: {
  children: ReactNode;
  durationSec?: number;
  className?: string;
}) {
  const items = Children.toArray(children);
  if (!items.length) return null;

  return (
    <div className={`marquee-host marquee-mask overflow-hidden ${className}`}>
      {/* Spacing lives on the items, not as a flex gap, so the duplicated half
          is exactly 50% of the track and the -50% loop is seamless. */}
      <div className="marquee-track" style={{ ["--marquee-duration" as string]: `${durationSec}s` }}>
        {items.map((child, i) => (
          <div key={`a-${i}`} className="shrink-0 pr-3">
            {child}
          </div>
        ))}
        {items.map((child, i) => (
          <div key={`b-${i}`} className="shrink-0 pr-3" aria-hidden>
            {child}
          </div>
        ))}
      </div>
    </div>
  );
}
